/* fs-bundles — multi-product bundle add-to-cart with a flavor-choice popup.
   - Cards stay clean. Hidden [data-bundle-slot] blocks carry each flavor slot's pills
     ([data-flavor] with variant/price/compare/img/label).
   - Add to Cart: if the bundle has ≥1 flavor slot → open a popup to pick each flavor,
     then add. No flavor slots → add immediately with the default variants. */
(function () {
  'use strict';

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function fmtMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, amount)
                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                   .replace(/&#36;/g, '$');
    }
    return '$' + amount;
  }

  /* Update the header cart-count badge(s) after an add. Self-contained: does NOT rely on
     window.fsUpdateCartCounts (that lives in fs-cart-popular.js, which only loads with the cart
     drawer — on the homepage the bundle add fired before it existed, so the header count never
     moved). /cart/add.js doesn't return the cart total, so fetch /cart.js for item_count. */
  function refreshCartCount() {
    if (typeof window.fsUpdateCartCounts === 'function') { window.fsUpdateCartCounts(); return; }
    fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = n < 100 ? n : ((window.cartStrings && window.cartStrings.item_99) || '99+');
        });
        document.querySelectorAll('[data-cart-text]').forEach(function (el) {
          if (!el.closest('.drawer__inner-empty')) el.textContent = '(' + n + ')';
        });
        document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
          if (n > 0) b.removeAttribute('hidden');
        });
      })
      .catch(function () {});
  }

  function addItems(ids, btn) {
    var items = ids.filter(Boolean).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    if (!items.length) return;
    var drawer = document.querySelector('cart-drawer');
    if (btn) btn.classList.add('is-loading');
    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function (json) {
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(json);
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: json }));
        if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('open')) drawer.open();
        if (btn) btn.classList.remove('is-loading');
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); window.location.href = cartRoot() + 'cart'; });
  }

  /* collect the bundle's current variant ids = single-slot defaults + chosen flavor per flavor-slot */
  function collectVariants(card, chosen) {
    var atc = card.querySelector('[data-add-bundle]');
    var def = (atc.getAttribute('data-variants') || '').split(',').filter(Boolean);
    // default flavor variants = first pill of each slot
    var slots = card.querySelectorAll('[data-bundle-slot]');
    var flavorDefaults = [];
    slots.forEach(function (s) {
      var first = s.querySelector('[data-flavor]');
      if (first) flavorDefaults.push(first.getAttribute('data-variant'));
    });
    var singles = def.filter(function (v) { return flavorDefaults.indexOf(v) === -1; });
    var picked = [];
    slots.forEach(function (s, idx) {
      var key = s.getAttribute('data-bundle-slot');
      var v = (chosen && chosen[key]) || (s.querySelector('[data-flavor]') && s.querySelector('[data-flavor]').getAttribute('data-variant'));
      if (v) picked.push(v);
    });
    return singles.concat(picked);
  }

  /* ---- popup ---- */
  function buildPopup(card) {
    var slots = card.querySelectorAll('[data-bundle-slot]');
    var format = (card.querySelector('[data-add-bundle]') || {}).getAttribute ? card.querySelector('[data-add-bundle]').getAttribute('data-money-format') : '';
    var name = (card.querySelector('.fs-bundle-card__name') || {}).textContent || 'your bundle';

    var overlay = document.createElement('div');
    overlay.className = 'fs-bundle-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var groups = '';
    slots.forEach(function (s) {
      var key = s.getAttribute('data-bundle-slot');
      var label = s.getAttribute('data-slot-label') || 'Choose option';
      var pills = '';
      s.querySelectorAll('[data-flavor]').forEach(function (p, i) {
        var dis = p.getAttribute('data-available') === '0';
        pills += '<button type="button" class="fs-bundle-modal__pill' + (i === 0 ? ' is-active' : '') + (dis ? ' is-disabled' : '') +
          '" data-modal-pill data-slot="' + key + '" data-variant="' + p.getAttribute('data-variant') + '"' + (dis ? ' disabled' : '') + '>' +
          p.textContent + '</button>';
      });
      groups += '<div class="fs-bundle-modal__group" data-modal-group="' + key + '">' +
        '<div class="fs-bundle-modal__group-label">' + label + '</div>' +
        '<div class="fs-bundle-modal__pills">' + pills + '</div></div>';
    });

    overlay.innerHTML =
      '<div class="fs-bundle-modal">' +
        '<button type="button" class="fs-bundle-modal__close" aria-label="Close" data-modal-close>&times;</button>' +
        '<div class="fs-bundle-modal__title">Choose your flavor</div>' +
        '<div class="fs-bundle-modal__sub">' + name + '</div>' +
        groups +
        '<button type="button" class="fs-bundle-modal__add" data-modal-add>Add to cart</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';

    var chosen = {};
    slots.forEach(function (s) {
      var first = s.querySelector('[data-flavor]');
      if (first) chosen[s.getAttribute('data-bundle-slot')] = first.getAttribute('data-variant');
    });

    function close() { overlay.remove(); document.documentElement.style.overflow = ''; }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('[data-modal-close]').addEventListener('click', close);
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });

    overlay.querySelectorAll('[data-modal-pill]').forEach(function (pill) {
      if (pill.disabled) return;
      pill.addEventListener('click', function () {
        var slot = pill.getAttribute('data-slot');
        overlay.querySelectorAll('[data-modal-pill][data-slot="' + slot + '"]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        chosen[slot] = pill.getAttribute('data-variant');
      });
    });

    overlay.querySelector('[data-modal-add]').addEventListener('click', function () {
      var ids = collectVariants(card, chosen);
      addItems(ids, card.querySelector('[data-add-bundle]'));
      close();
    });
  }

  function onAdd(e) {
    var btn = e.currentTarget;
    var card = btn.closest('[data-bundle-card]') || btn.closest('.fs-bundle-card');
    if (!card) { addItems((btn.getAttribute('data-variants') || '').split(','), btn); return; }
    var hasFlavor = card.querySelector('[data-bundle-slot] [data-flavor]');
    if (hasFlavor) { buildPopup(card); }
    else { addItems((btn.getAttribute('data-variants') || '').split(','), btn); }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-add-bundle]').forEach(function (b) {
      if (b.__fsBundleBound) return; b.__fsBundleBound = true;
      b.addEventListener('click', onAdd);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
